<script setup>

import Width from "@/pages/Index/Width.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
// import rightEquipment from "@/assets/images/manufacture/equipment1.png"
// import leftEquipment from "@/assets/images/manufacture/equipment2.png"
const leftEquipment = 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1744764182_GmCsnT223D.png'
const rightEquipment = 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1744764137_G7S92NsXjH.png'
</script>

<template>
	<div class="equipment">
		<Width>
			<div class="equipment__content">
				<div class="equipment__content__title">
					{{ $t('manufacture.equipments.title') }}
				</div>
				
				<div class="equipment__content__desc">
					{{ $t('manufacture.equipments.content') }}
				</div>
				
				<div class="equipment__content__equipment">
					
					<div class="parallelogram parallelogram--unfill">
						<div
							class="parallelogram__title parallelogram__title--left"
						>
							<div
								class="parallelogram__title__content"
							>
								{{ $t('manufacture.equipments.MeasuringInstrument') }}
							</div>
						</div>
						
						<div class="left-img">
							<el-image :src="leftEquipment"  />
						</div>
					</div>
					
					<div class="and">
						<SvgIcon name="and" class-name="and-icon" />
					</div>
					
					<div class="parallelogram parallelogram--fill">
						<div class="right-img">
							<el-image :src="rightEquipment" />
						</div>
						<div
							class="parallelogram__title parallelogram__title--right"
						>
							<div
								class="parallelogram__title__content"
							>
								{{ $t('manufacture.equipments.MachiningCenter') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.equipment {
	background-image: url("~@/assets/images/bg/equipment.png");
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 72px 0;
	overflow: hidden;
	
	&__content {
		color: #3D3D3D;
		
		&__title {
			font-size: 48px;
			font-weight: bold;
			margin-bottom: 48px;
		}
		
		&__desc {
			font-size: 18px;
			line-height: 32px;
		}
		
		&__equipment {
			margin-top: 48px;
			display: flex;
			justify-content: center;
			position: relative;
			
			.right-img,
			.left-img {
				position: absolute;
				z-index: 1;
			}
			
			.left-img {
				left: 50%;
				top: 70%;
				transform: skew(15deg) translate(-50%, -70%) scale(2);
			}
			
			.right-img {
				right: 0;
				top: 45%;
				transform: skew(15deg) translate(30%, -45%) scale(1.1);
			}
			
			.and {
				z-index: 1;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				&-icon {
					font-size: 300px;
				}
			}
			
			.parallelogram {
				width: 30%;
				height: 486px;
				transform: skew(-15deg);
				box-sizing: border-box;
				border-radius: 24px;
				position: relative;
				
				&__title {
					position: absolute;
					padding: 10px 24px;
					border-radius: 8px;
					box-shadow: 0 4px 10px 0 rgba(50, 2, 2, 0.2);
					transform: skew(-15deg);
					z-index: 1;
					
					&__content {
						font-size: 18px;
						font-weight: bold;
						transform: skew(15deg);
					}
					
					&--left {
						left: -90px;
						top: 50px;
						background: linear-gradient(279deg, #D1170E 3%, #F46760 100%), linear-gradient(279deg, #DA241B 0%, #F0554D 100%);
						color: #FFFFFF;
					}
					
					&--right {
						right: -90px;
						bottom: 50px;
						background: #FFFFFF;
						
						.parallelogram__title__content {
							background: linear-gradient(277deg, #D1170E 3%, #F46760 100%), linear-gradient(277deg, #DA241B 0%, #F0554D 100%);
							-webkit-background-clip: text;
							-webkit-text-fill-color: transparent;
							background-clip: text;
							text-fill-color: transparent;
						}
					}
				}
				
				&--fill {
					margin-top: 120px;
					background: linear-gradient(317deg, #D1170E 3%, #F46760 100%);
				}
				
				&--unfill {
					border: 2px solid @primary-color;
					background: rgba(255, 255, 255, 0.6);
				}
			}
		}
		
	}
}

@media only screen and (max-width: 1400px) {
	.equipment {
		
		&__content {
			
			&__equipment {
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(1.5);
				}

				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1.1);
				}
				
				
			}
		}
	}
}

@media only screen and (max-width: 1200px) {
	.equipment {
		
		&__content {
			
			&__equipment {
				
				.right-img,
				.left-img {
					//width: 300px;
					//height: 300px;
				}
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(1.5);
				}

				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1.1);
				}
				
				
			}
		}
	}
}

@media only screen and (max-width: 1024px) {
	.equipment {
		
		&__content {
			
			&__equipment {
				
				.right-img,
				.left-img {
					//width: 280px;
					//height: 280px;
				}
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(1.5);
				}
				
				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1);
				}
			
				.parallelogram {
					width: 35%;
				}
				
			}
		}
	}
}

@media only screen and (max-width: 768px) {
	.equipment {
		padding: 30px 0;
		&__content {
			
			&__title {
				font-size: 24px;
				margin-bottom: 16px;
			}
			
			&__desc {
				font-size: 16px;
				line-height: 28px;
			}
			
			.and {
				
				&-icon {
					font-size: 200px;
				}
			}
			
			&__equipment {
				margin-top: 16px;
				
				.right-img,
				.left-img {
					//width: 240px;
					//height: 240px;
				}
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(1.5);
				}
				
				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1.1);
				}
				
				.parallelogram {
					width: 40%;
				}
				
			}
		}
	}
}

@media only screen and (max-width: 535px) {
	.equipment {
		padding: 30px 0;
		&__content {
			
			.and {
				
				&-icon {
					font-size: 150px;
				}
			}
			
			&__equipment {
				
				.right-img,
				.left-img {
					//width: 180px;
					//height: 180px;
				}
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(2);
				}
				
				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1.1);
				}
				
				.parallelogram {
					height: 280px;
					border-radius: 10px;
					
					&__title {
						padding: 5px;
						border-radius: 5px;
						
						&__content {
							font-size: 12px;
						}
						
						&--left {
							left: -20px;
							top: 20px;
						}
						
						&--right {
							right: -20px;
							bottom: 20px;
							background: #FFFFFF;
						}
					}
					
				}
				
			}
		}
	}
}

@media only screen and (max-width: 414px) {
	.equipment {
		padding: 30px 0;
		&__content {
			
			&__title {
				font-size: 18px;
				margin-bottom: 20px;
			}
			
			&__desc {
				font-size: 14px;
				line-height: 24px;
			}
			
			.and {
				
				&-icon {
					font-size: 150px;
				}
			}
			
			&__equipment {
				
				.right-img,
				.left-img {
					//width: 150px;
					//height: 150px;
				}
				
				.left-img {
					left: 50%;
					top: 70%;
					transform: skew(15deg) translate(-50%, -70%) scale(1.5);
				}
				
				.right-img {
					right: 0;
					top: 60%;
					transform: skew(15deg) translate(30%, -60%) scale(1.1);
				}
				
				.parallelogram {
					height: 240px;
				}
				
			}
		}
	}
}
</style>